import { Context, type Effect } from "effect";
import type { WorkspaceBaseline, HistoryClientFailure } from "./model.ts";
export interface WorkspaceChangesApiShape {
  readonly baseline: (workspaceId: string) => Effect.Effect<WorkspaceBaseline, HistoryClientFailure>;
}
export class WorkspaceChangesApi extends Context.Service<WorkspaceChangesApi, WorkspaceChangesApiShape>()("workerstation/frontend/WorkspaceChangesApi") {}
